import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Flex, Text } from "sprout-ui-primitives";
import { LandingPage, LandingH2, LandingH2P, LandingSectionMaxWidth, LandingMaxWidth, LandingSection, LandingH1, LandingH1P, LandingVideo } from "sprout-ui-dom/dist/Landing";
import { Google } from "sprout-ui-dom/dist/Authenticate";
import { Link } from "react-router-dom";
import Head from "@sprout/client-layout/dist/Head";
import styled from "styled-components";
import { Button } from "sprout-ui-dom";
const SignUpButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  height: 80px;
  padding: 4px;

  width: 100%;
  max-width: 320px;
  background: #4285f4;
`;
const PublicPage = ()=>{
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                title: "Task management, project management, collaboration",
                description: "Sprout is a daily planner that brings together your to-dos, notes, bookmarks, and project information to reduce overwhelm."
            }),
            /*#__PURE__*/ _jsxs(LandingPage, {
                children: [
                    /*#__PURE__*/ _jsxs(LandingSectionMaxWidth, {
                        children: [
                            /*#__PURE__*/ _jsx(LandingH1, {
                                children: "Fast & simple daily planner"
                            }),
                            /*#__PURE__*/ _jsx(LandingH1P, {
                                mt: 8,
                                children: "Sprout is a daily planner that brings together your to-dos, notes, bookmarks, and project information to reduce overwhelm."
                            }),
                            /*#__PURE__*/ _jsx(Box, {
                                mt: 11,
                                textAlign: "center",
                                children: /*#__PURE__*/ _jsxs(SignUpButton, {
                                    as: "a",
                                    href: "/auth/google",
                                    children: [
                                        /*#__PURE__*/ _jsx(Flex, {
                                            flex: "none",
                                            width: "72px",
                                            height: "100%",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            bg: "white.100",
                                            children: /*#__PURE__*/ _jsx(Google, {})
                                        }),
                                        /*#__PURE__*/ _jsx(Box, {
                                            width: "100%",
                                            textAlign: "center",
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                textTransform: "uppercase",
                                                fontWeight: "bold",
                                                color: "white.100",
                                                children: "Sign up with Google"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(LandingSection, {
                        mt: 11,
                        px: [
                            7,
                            7,
                            7,
                            "160px"
                        ],
                        children: /*#__PURE__*/ _jsxs(LandingMaxWidth, {
                            maxWidth: "1400px",
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    as: "p",
                                    fontWeight: "bold",
                                    fontSize: 5,
                                    textAlign: "center",
                                    children: "Watch an overview to see how it works"
                                }),
                                /*#__PURE__*/ _jsx(LandingVideo, {
                                    position: "relative",
                                    bg: "white.100",
                                    my: 8,
                                    borderRadius: null,
                                    children: /*#__PURE__*/ _jsx("iframe", {
                                        src: "https://www.youtube.com/embed/2prrkt-GC-U",
                                        title: "YouTube video player",
                                        frameBorder: "0",
                                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                        allowFullScreen: true
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    textAlign: "center",
                                    mt: "96px",
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        as: Link,
                                        to: "/features",
                                        textDecoration: "underline",
                                        color: "blue.500",
                                        fontWeight: "medium",
                                        fontSize: 4,
                                        children: "See what Sprout can do in the features tour"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs(LandingSectionMaxWidth, {
                        mt: "128px",
                        children: [
                            /*#__PURE__*/ _jsx(LandingH2, {
                                children: "How is Sprout different?"
                            }),
                            /*#__PURE__*/ _jsxs(LandingH2P, {
                                mt: 8,
                                children: [
                                    "Sprout\u2019s tree-like groupings provide",
                                    " ",
                                    /*#__PURE__*/ _jsx("em", {
                                        children: "a centralized place for your to-dos, notes, bookmarks, and project information"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(LandingH2P, {
                                mt: 4,
                                children: [
                                    "Workflows help you ",
                                    /*#__PURE__*/ _jsx("em", {
                                        children: "process online information"
                                    }),
                                    " e.g. read later, tasks, project information, and share links."
                                ]
                            }),
                            /*#__PURE__*/ _jsx(LandingH2P, {
                                mt: 4,
                                children: "Sprout Agenda lets you prioritize work, schedule it, and set deadlines."
                            }),
                            /*#__PURE__*/ _jsxs(LandingH2P, {
                                mt: 4,
                                children: [
                                    "Things no longer fall through the cracks \u2013",
                                    " ",
                                    /*#__PURE__*/ _jsx("em", {
                                        children: "a sense of calm sets in"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export default PublicPage;
